import {connect} from "react-redux";
import * as VideoQuestionActions from "../../store/actions/videoQuestionActions";
import EditVideoQuestions from "../../components/EditChapterPart/EditVideoQuestions";

const mapStateToProps = (state) => ({
    ...state.videoQuestions
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: () => {
        dispatch(VideoQuestionActions.getVideoQuestions());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditVideoQuestions);



// WEBPACK FOOTER //
// ./src/containers/EditChapterPart/EditVideoQuestionsContainer.js